import Vue from 'vue'
import Vuex from 'vuex'
import { estico } from '@/store/actions/estico'
import Order from '@/store/actions/order'
import EsticoMutations from '@/store/mutations/estico'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    description: null,
    total_price: 0,
    shipping_amount: 0,
    price: 0,
    loader: true,
    checkout: null,
    customer: null,
    shipping: null,
    payment: null,
    gtag: false,
    payment_select: '',
    customer_name: '',
    customer_email: '',
    customer_cpf: '',
    customer_phone: '',
    address_zipcode: null,
    address_street: null,
    address_number: null,
    address_neighborhood: null,
    address_complement: null,
    address_city: null,
    address_uf: null,
    payment_method: null,
    paymentSelect: null,
    cardBin: null,
    cardDueDate: null,
    cardCvv: null,
    cardBrand: null,
    cardPlots: null,
    cardHolderName: null,
    cardBirthDate: null,
    credit_card: null,
    boleto: null,
    card: null,
    slug: null
  },
  getters: {
    customer: state => {
      return {
        customer_name: state.customer_name,
        customer_email: state.customer_email,
        customer_cpf: state.customer_cpf,
        customer_phone: state.customer_phone
      }
    },
    address: state => {
      return {
        address_zipcode: state.address_zipcode,
        address_street: state.address_street,
        address_number: state.address_number,
        address_neighborhood: state.address_neighborhood,
        address_complement: state.address_complement,
        address_city: state.address_city,
        address_uf: state.address_uf
      }
    },
    payment: state => {
      return {
        paymentSelect: state.paymentSelect
      }
    },
    card: state => {
      if (state.cardToken) {
        return {
          token: state.card,
          cardPlots: state.cardPlots,
          cardHolderName: state.cardHolderName,
          cardBirthDate: state.cardBirthDate,
          cardBrand: state.cardBrand
        }
      }
      return {
        cardBin: state.cardBin,
        cardBrand: state.cardBrand,
        cardDueDate: state.cardDueDate,
        cardCvv: state.cardCvv,
        cardPlots: state.cardPlots,
        cardHolderName: state.cardHolderName,
        cardBirthDate: state.cardBirthDate
      }
    }
  },
  mutations: {
    loader (state) {
      state.loader = !state.loader
    },
    ZIPCODE (state, payload) {
      state.address_zipcode = payload
    },
    CARDTOKEN (state, payload) {
      state.cardToken = payload
    },
    STREET (state, payload) {
      state.address_street = payload
    },
    ADDRESS (state, payload) {
      state.address_street = payload.logradouro
      state.address_neighborhood = payload.bairro
      state.address_city = payload.localidade
      state.address_uf = payload.uf
    },
    ...EsticoMutations
  },
  actions: {
    ...estico,
    ...Order
  },
  modules: {
  }
})
